import Curl from '$common/utils/curl/browser-curl';
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import { gateway_web as pix } from '../api-pix';
const appgatewayHost = new UrlModules({ module: 'appgateway' });
const defaultCurl = (params, url, config) => new Curl().curl(params, `${appgatewayHost.host}/${pix}/${url}`, config);
import { curlGateWay } from '$common/api/curl';
/**
 * 发送登录短信验证码
 * @param {*} params
 */
export const sendLoginSms = (params, config) => defaultCurl(params, `operator/login/sendLoginSms.do`, config);
/**
 * 短信登录
 * @param {*} params
 */
export const smsLogin = (params, config) => defaultCurl(params, `operator/login/smsLogin.do`, config);

/**
 * 微信绑定手机号
 * @param {*} params
 */
export const sendWxBindPhone = (params, config) => defaultCurl(params, `operator/register/bindLoginName.do`, config);
/**
 * H5浏览器助力进入，绑定或注册接口
 * @param {*} params
 */
export const sendwebBindReg = (params, config) => defaultCurl(params, `operator/register/wechatRegisterAndBind.do`, config);
/**
 * 纯注册不登录接口
 * @param {*} params 
 * @param {*} config 
 * @returns 
 */
export const smsRegister = (params, config) => defaultCurl(params, `/operator/login/smsRegister.do`, config);


